import type { Jsonifiable } from 'type-fest';

const encoder = new TextEncoder();
const decoder = new TextDecoder();

/**
 * Truncates a body value for logging purposes.
 * Handles undefined/null, binary (Uint8Array), strings and JSON-serializable objects.
 * Truncation is performed by UTF-8 byte length.
 */
export function truncate(body: unknown, maxBytes: number): Jsonifiable {
	if (body === undefined || body === null) {
		return null;
	}

	if (body instanceof Uint8Array) {
		return `[binary ${String(body.byteLength)} bytes]`;
	}

	const serialized = typeof body === 'string' ? body : JSON.stringify(body);

	// Fast path: string.length <= UTF-8 byte length always,
	// so if chars fit — bytes fit too (exact for ASCII, ≈99% of JSON).
	if (serialized.length <= maxBytes) {
		return body as Jsonifiable;
	}

	// Encode only when truncation is needed
	const encoded = encoder.encode(serialized);
	const truncated = decoder.decode(encoded.subarray(0, maxBytes));
	return `${truncated}... [truncated, total ${String(encoded.byteLength)} bytes]`;
}
